"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "castel-viscardo": {
    "a252522c": [{
      "hkey": "c55be34c",
      "slug": "castel-viscardo",
      "name": "Castel Viscardo",
      "primary": true,
      "skipSearch": false
    }],
    "borgata": [{
      "hkey": "c55be34c",
      "slug": "castel-viscardo",
      "name": "Castel Viscardo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c8ea315e": [{
      "hkey": "1cab3797",
      "slug": "le-prese-zona-industriale",
      "name": "Le Prese-Zona Industriale",
      "primary": true,
      "skipSearch": false
    }],
    "le-prese": [{
      "hkey": "1cab3797",
      "slug": "le-prese-zona-industriale",
      "name": "Le Prese-Zona Industriale",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;